(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-profile/views/pages/profile.js') >= 0) return;  svs.modules.push('/modules/player-profile/views/pages/profile.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.player_profile=_svs.player_profile||{};
_svs.player_profile.templates=_svs.player_profile.templates||{};
svs.player_profile.templates.profile = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"components-accountservices-player_details-player_details"),depth0,{"name":"components-accountservices-player_details-player_details","hash":{"action":(depth0 != null ? lookupProperty(depth0,"action") : depth0),"model":(depth0 != null ? lookupProperty(depth0,"model") : depth0)},"data":data,"indent":"      ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    return "      <div class=\"js-profile-loader-container profile-loader-container\"></div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }, buffer = 
  "<div class=\"profile-content profile-hbs\">\n  <div id=\"containerRegion\">\n";
  stack1 = ((helper = (helper = lookupProperty(helpers,"isServerSide") || (depth0 != null ? lookupProperty(depth0,"isServerSide") : depth0)) != null ? helper : container.hooks.helperMissing),(options={"name":"isServerSide","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":7,"column":21}}}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!lookupProperty(helpers,"isServerSide")) { stack1 = container.hooks.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + "  </div>\n</div>\n";
},"usePartial":true,"useData":true});
Handlebars.partials['svs-player_profile-profile'] = svs.player_profile.templates.profile;
})(svs, Handlebars);


 })(window);